import { useEffect, useMemo, useState } from "react";
import { useAppSelector } from "@/app_redux/hooks/root_hook";

export const useMirrorPresenceStatus = () => {
  const [presenting, setPresenting] = useState(false);

  const rawVmsUserId = useAppSelector((state) => state.auth?.vms_user_id);

  const sseUrl = useMemo(() => {
    if (!rawVmsUserId) return null;
    const cartBaseUrl = import.meta.env.VITE_CART_URL;
    if (!cartBaseUrl) return null;
    return `${cartBaseUrl}/vms/cart/mirror-status/stream?vms_user_id=${encodeURIComponent(rawVmsUserId)}`;
  }, [rawVmsUserId]);

  useEffect(() => {
    console.log("[MirrorPresence] vms_user_id:", rawVmsUserId, "sseUrl:", sseUrl);

    if (!sseUrl) {
      setPresenting(false);
      return;
    }

    const es = new EventSource(sseUrl);

    es.onmessage = (event) => {
      console.log("[MirrorPresence] SSE data:", event.data);
      try {
        const data = JSON.parse(event.data);
        if (typeof data.presenting === "boolean") {
          setPresenting(data.presenting);
        }
      } catch {
        // Ignore malformed events
      }
    };

    return () => {
      es.close();
    };
  }, [sseUrl, rawVmsUserId]);

  return { presenting };
};
